import { Link } from "react-router-dom";

const ServicesSection = () => {
  return (
    <div className=" bg-white py-10 px-0 md:px-6">
      <div>
        <div className="text-center mb-6">
          <h2 className="text-[21px] lg:text-3xl font-bold text-gray-900">
            Our Services
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-600 w-[95%] md:max-w-4xl mx-auto mt-1">
            Established in 2007, PVRCabs is a leading and highly experienced transport service provider in Hyderabad. As a locally owned and operated company, we take pride in our contribution to the local economy and its continuous growth.     </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-[90%] md:w-full mx-auto">
          {/* Service Card 1 - IT Employee Transportation */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform ">
            <div
              className="h-48 bg-cover bg-center relative"
              style={{
                backgroundImage: `url('/EmployeeTransit.png')`
              }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>
              <div className="absolute bottom-4 left-4">
                <h3 className="text-base md:text-lg lg:text-xl font-extrabold text-white">IT Employee Transportation</h3>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm md:text-sm lg:text-base text-gray-900 mb-2">
                PVR Cabs has solidified its position as the foremost transportation provider in Hyderabad, particularly excelling in Employee Transportation Services. Recognizing Hyderabad's prominence
              </p>

              <Link to="/employee-transportation" className="text-xs md:text-sm text-blue-600 font-medium hover:text-blue-800 inline-flex items-center">
                Read more
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>

          {/* Service Card 2 - Corporate Car */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform ">
            <div
              className="h-48 bg-cover bg-center relative"
              style={{
                backgroundImage: `url('/CorpCar.png')`
              }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>
              <div className="absolute bottom-4 left-4">
                <h3 className="text-base md:text-lg lg:text-xl font-extrabold text-white">Corporate Car</h3>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm md:text-sm lg:text-base text-gray-900 mb-2">
                Our corporate car rental service is spread across Telangana, Hyderabad for all major companies. Corporate organizations need to devote their precious time on implementing transport services
              </p>

              <Link to="/corporate-car" className="text-xs md:text-sm text-blue-600 font-medium hover:text-blue-800 inline-flex items-center">
                Read more
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>

          {/* Service Card 3 - Airport Transfer */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform ">
            <div
              className="h-48 bg-cover bg-center relative"
              style={{
                backgroundImage: `url('/AirportRide.png')`
              }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>
              <div className="absolute bottom-4 left-4">
                <h3 className="text-base md:text-lg lg:text-xl font-extrabold text-white">Airport Transfer</h3>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm md:text-sm lg:text-base text-gray-900 mb-2">
                Booking airport transfer services with PVR CABS offers several advantages for businesses hosting delegates or organizing outstation conferences.Punctuality: Timeliness
              </p>

              <Link to="/airport-transfer" className="text-xs md:text-sm text-blue-600 font-medium hover:text-blue-800 inline-flex items-center">
                Read more
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;